import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mt-3" }

import { ref, onMounted, inject } from "vue";
import SystemService from "../../../services/SystemService";
import notification from "@/core/plugins/notification";
import { ElLoading } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditGroupPermissions',
  setup(__props) {

const groupData = inject<any>("groupData");
const permissions = inject<any>("permissions");
const rolePermissions = ref<any>([]);
const finalPermissions = ref<any>([]);

const fecthData = async () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  try {
    const res = await SystemService.getPermissionRolesById(groupData.value.id);
    rolePermissions.value = res;
    await processPermissions();
  } catch (error) {
    console.log(error);
    notification.danger();
  }
  loading.close();
};

const togglePermission = async (permission: any) => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  try {
    await SystemService.updateRolePermission(groupData.value.id, permission.id);
  } catch (error) {
    console.log(error);
    notification.danger();
  }
  loading.close();
};

const processPermissions = async () => {
  finalPermissions.value = permissions.value.map((item: any) => {
    return {
      ...item,
      type: getCategoryName(item.action, item.category),
      action: reNameAction(item.action),
      own: rolePermissions.value.includes(item.id),
    };
  });
  finalPermissions.value = finalPermissions.value.reduce((acc, item) => {
    // Remove the $ suffix for grouping
    const normalizedType = item.type.replace(/\$$/, "");

    if (!acc[normalizedType]) {
      acc[normalizedType] = [];
    }
    acc[normalizedType].push(item);
    return acc;
  }, {});

  const sortedKeys = Object.keys(finalPermissions.value).sort((a, b) =>
    a.localeCompare(b)
  );
  const sortedPermissions = {};

  for (const key of sortedKeys) {
    sortedPermissions[key] = finalPermissions.value[key];
  }

  finalPermissions.value = sortedPermissions;
  console.log(finalPermissions.value);
};

const getCategoryName = (name: string, type: string) => {
  if (type === "API") {
    const subString = name.split("/tenant/")[1];
    return subString === undefined ? name : subString.split("/")[0];
  } else {
    return type;
  }
};

const reNameAction = (name: string) => {
  const subString = name.split("/tenant/")[1];
  return subString === undefined ? name : subString;
};

onMounted(async () => {
  await fecthData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(groupData).name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalPermissions.value, (apiType, i) => {
        return (_openBlock(), _createElementBlock("div", { key: i }, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(i), 1),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiType, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 8,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      border: "",
                      class: "my-4",
                      style: {"width":"90%"},
                      onChange: ($event: any) => (togglePermission(item)),
                      checked: item.own == true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.id) + " | " + _toDisplayString(item.method) + " | " + _toDisplayString(item.action), 1)
                      ]),
                      _: 2
                    }, 1032, ["onChange", "checked"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ])
  ]))
}
}

})